/**
 * Route for `leaderboard`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LeaderboardPage } from "../features/leaderboard/LeaderboardPage";

export const leaderboardRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/leaderboard",
	component: LeaderboardPage,
});

export default leaderboardRoute;
